import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { GetDocuments } from '../../../api/documentApi';

// INTERFACE_DOCUMENT
interface Document {
    id: string;
    document_type: string;
    content: string;
}

// INTERFACE_STATE
interface DocumentsState {
    documents: Document[];
    loading: boolean;
    error: string | null;
    status: number | null;
    selectedDocument: Document | null;
    isDocumentModalOpen: boolean;
}

// INITIAL_STATE
const initialState: DocumentsState = {
    documents: [],
    loading: false,
    error: null,
    status: null,
    selectedDocument: null,
    isDocumentModalOpen: false,
};

// ASYNC_THUNK - GET_DOCUMENTS
export const fetchDocuments = createAsyncThunk(
    'documents/fetchDocuments',
    async ( _,{ rejectWithValue }) => {
        try {
            const result = await GetDocuments();

            if (result.status >= 200 && result.status < 300) {


                if ('results' in result.data && Array.isArray(result.data.results)) {

                    return {
                        documents: result.data.results,
                        status: result.status,
                    };
                }


            }

            if ('errors' in result.data) {
                const errorMessages = result.data.errors
                    .map((err) => err.detail)
                    .join(', ');
                return rejectWithValue({
                    error: errorMessages,
                    status: result.status,
                });
            }

            // Generic error
            if ('error' in result.data) {
                return rejectWithValue({
                    error: result.data.error,
                    status: result.status,
                });
            }

            return rejectWithValue({
                error: 'Bilinməyən xəta baş verdi',
                status: result.status,
            });
        } catch (error) {
            console.error('Catch Error:', error);
            return rejectWithValue({
                error: error instanceof Error ? error.message : 'Gözlənilməz xəta',
                status: -1,
            });
        }
    }
);

// SLICE
const documentsSlice = createSlice({
    name: 'documents',
    initialState,
    reducers: {


        openDocumentModal: (state, action: PayloadAction<string>) => {
            const docType = action.payload;
            const document = state.documents.find(
                doc => doc.document_type === docType
            );
            if (document) {
                state.selectedDocument = document;
                state.isDocumentModalOpen = true;
            }
        },

        closeDocumentModal: (state) => {
            state.selectedDocument = null;
            state.isDocumentModalOpen = false;
        },



        // Clear errors
        clearError: (state) => {
            state.error = null;
        },

    },extraReducers: (builder) => {
        builder
            // Fetch documents - pending
            .addCase(fetchDocuments.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            // Fetch documents - fulfilled
            .addCase(fetchDocuments.fulfilled, (state, action: PayloadAction<{
                documents: Document[];
                status: number;
            }>) => {


                state.loading = false;
                state.documents = action.payload.documents;
                state.status = action.payload.status;
                state.error = null;

            })
            .addCase(fetchDocuments.rejected, (state, action) => {


                state.loading = false;
                state.documents = [];

                if (action.payload) {
                    const payload = action.payload as { error: string; status: number };
                    state.error = payload.error;
                    state.status = payload.status;
                } else {
                    state.error = action.error.message || 'Xəta baş verdi';
                    state.status = -1;
                }
            });
    },
});

// EXPORTS
export const {

    openDocumentModal,
    closeDocumentModal
} = documentsSlice.actions;

export default documentsSlice.reducer;